import { DrawerItem } from "@gisce/oficina-virtual-components"
import { useTranslation } from "react-i18next"
import { useLocation, useNavigate } from "react-router";
import {
  Person,
  PersonAdd,
  Message,
  Savings,
  AutoGraph,
} from "@mui/icons-material";
import ContractationListItems from "../../CustomItems/ContractationListItems";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";

export const UngroupedSideBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const Settings = useSettingsContext();
  const { pathname } = useLocation();

  return <>
    
      <DrawerItem
        icon={<Person />}
        label={t('common:text.login_title')}
        onClick={() => navigate(t('common:url.login'))}
        selected={pathname == t('common:url.login')}
      />
      {Settings.features?.signup && <DrawerItem
        icon={<PersonAdd />}
        label={t('common:text.login_view_button_activate')}
        onClick={() => navigate(t('common:url.activate'))}
        selected={pathname == t('common:url.activate')}
        />}
      {!Settings.contractation?.authenticate &&
        Settings.features?.sidebarContract &&
        <ContractationListItems />
      }
      {Settings.features?.unsignedContact &&
        Settings.features?.contact && <DrawerItem
        icon={<Message />}
        label={t('common:text.contact_title')}
        onClick={() => navigate(t('common:url.unsigned_contact'))}
        selected={pathname == t('common:url.unsigned_contact')}
        />}
      {Settings?.comparator?.enabled && <DrawerItem
        icon={<Savings />}
        label={t('common:text.menu_price_comparator_title')}
        onClick={() => navigate(t('common:url.priceComparator'))}
        selected={pathname == t('common:url.priceComparator')}
        />}
      {Settings?.powerCalculator?.enabled && <DrawerItem
        icon={<AutoGraph />}
        label={t('common:text.menu_power_calculator_title')}
        onClick={() => navigate(t('common:url.powerCalculator'))}
        selected={pathname == t('common:url.powerCalculator')}
      />}
  </>
}
